const getIndexOf = (item, itemArray) =>
  itemArray.findIndex((entry) => entry === item);

export default getIndexOf;
